import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import type { GetClaimIntegrationStatusRequestDto } from "../../dtos/get-claim-integration-status-request-dto";
import type { GetIntegrationStatusResponseDto } from "../../dtos/get-integration-status-response-dto";
import { OrderQueryKeys } from "../../generators/order-query-keys";
import { OrderService } from "../../services/order-service";

type UseGetClaimIntegrationStatusQueryParams = {
  queryParams: GetClaimIntegrationStatusRequestDto;
  options?: Omit<UseQueryOptions<GetIntegrationStatusResponseDto>, "queryKey">;
};

export const useGetClaimIntegrationStatusQuery = ({
  queryParams,
  options
}: UseGetClaimIntegrationStatusQueryParams) => {
  return useQuery({
    queryKey: OrderQueryKeys.getClaimIntegrationStatus(queryParams.public_id)
      .queryKey,
    queryFn: async () =>
      await OrderService.getClaimIntegrationStatus({ payload: queryParams }),
    ...options
  });
};
